module.exports = __webpack_public_path__ + "img/cancel-button.2ca74713.svg";